// Tipos de adicionais que um móvel pode ter.
//
// Os booleans abaixo continuam existindo POR COMPATIBILIDADE — pedidos
// antigos seguem com flags individuais (baseMadeira, pePalito, rodinhas,
// baseMetalon). O PainelMovel novo agrupa essas 4 num radio único de
// "Base" e popula os booleans equivalentes no salvar, pra Terceirizados
// e gerarResumo (Logística/Kanban) continuarem detectando.
export const ADICIONAIS_BOOLEAN = [
  { key: 'rodinhas',      label: 'Rodinhas'        },
  { key: 'pePalito',      label: 'Pé palito'       },
  { key: 'baseMadeira',   label: 'Base madeira'    },
  { key: 'baseMetalon',   label: 'Base metalon'    },
  { key: 'moldura',       label: 'Moldura'         },
  { key: 'espessura25mm', label: 'Espessura 25 mm' },
]

// Subset dos booleans que aparece no painel de adicionais agora —
// os outros 4 viraram opções do radio Base.
export const ADICIONAIS_EXTRAS = [
  { key: 'moldura',       label: 'Moldura'         },
  { key: 'espessura25mm', label: 'Espessura 25 mm' },
]

export const ADICIONAIS_QUANTIDADE = [
  { key: 'gavetaBranco',    label: 'Gaveta branco'             },
  { key: 'gavetaCor',       label: 'Gaveta cor'                },
  { key: 'chaves',          label: 'Chaves'                    },
  { key: 'prateleiraBranco',label: 'Prateleira adicional branco'},
  { key: 'prateleiraCor',   label: 'Prateleira adicional cor'  },
]

// ── Base (radio obrigatório) ────────────────────────────────────────────────
// Toda peça precisa indicar qual é a base. Os 4 primeiros vão pra Terceirizados;
// os 2 últimos ("Sem base") são móveis suspensos ou apoiados em sapatinhas
// (não geram compra de terceiro).
export const BASES = [
  { id: 'mdf',           label: 'Base em MDF'           },
  { id: 'madeira',       label: 'Base de madeira'       },
  { id: 'pePalito',      label: 'Pés palito'            },
  { id: 'rodinhas',      label: 'Rodinhas'              },
  { id: 'metalon',       label: 'Base em metalon'       },
  { id: 'semSuspenso',   label: 'Sem base (suspenso)'   },
  { id: 'semSapatinhas', label: 'Sem base (sapatinhas)' },
]

// Mapa Base → flag boolean equivalente, pra compat com Terceirizados etc.
export const BASE_TO_FLAG = {
  madeira:  'baseMadeira',
  pePalito: 'pePalito',
  rodinhas: 'rodinhas',
  metalon:  'baseMetalon',
}

// ── Puxador ──────────────────────────────────────────────────────────────────
// "Sem puxador" é a primeira opção — escolha explícita pra evitar esquecer.
// "Perfil" é tipo de puxador embutido (vai no canto da porta); cores específicas.
export const PUXADOR_TIPOS = [
  'Sem puxador',
  'Fecho e toque',
  'Cava',
  'Alça',
  'Concha',
  'Ponto',
  'Perfil',
  'Passante',
]

// Tipos que não exigem seleção de cor
export const PUXADOR_TIPOS_SEM_COR = ['Sem puxador', 'Cava', 'Fecho e toque', 'Passante']
// Tipos que não exigem quantidade (é peça única ou não tem)
export const PUXADOR_TIPOS_SEM_QTD = ['Sem puxador', 'Cava', 'Passante']

export const PUXADOR_CORES = [
  { nome: 'Preto',         hex: '#1A1A1A' },
  { nome: 'Prata Cromado', hex: '#C0C0C0' },
  { nome: 'Prata Fosco',   hex: '#8A8A8A' },
  { nome: 'Bronze',        hex: '#8B6914' },
  { nome: 'Dourado',       hex: '#D4AF37' },
]

// Cores específicas do puxador Perfil
export const PUXADOR_CORES_PERFIL = [
  { nome: 'Prata',  hex: '#C0C0C0' },
  { nome: 'Preto',  hex: '#1A1A1A' },
  { nome: 'Branco', hex: '#FFFFFF' },
]

export const ADICIONAIS_DEFAULT = {
  rodinhas:        false,
  pePalito:        false,
  baseMadeira:     false,
  baseMetalon:     false,
  moldura:         false,
  espessura25mm:   false,
  puxadorTipo:     '',
  puxadorCor:      '',
  puxadorQtd:      0,
  gavetaBranco:    0,
  gavetaCor:       0,
  chaves:          0,
  prateleiraBranco:0,
  prateleiraCor:   0,
  // Novos campos do painel atualizado
  base:            '',     // id em BASES — obrigatório no novo fluxo
  semAdicionais:   false,  // marca "explicitamente sem moldura/25mm"
}

// Infere a `base` a partir das flags antigas (rodinhas, pePalito,
// baseMadeira, baseMetalon) pra editar um móvel cadastrado antes do
// campo Base existir. Se nada bate, retorna '' — usuário precisa
// escolher antes de salvar.
export function inferirBase(adicionais) {
  if (!adicionais) return ''
  if (adicionais.base) return adicionais.base
  if (adicionais.baseMadeira) return 'madeira'
  if (adicionais.baseMetalon) return 'metalon'
  if (adicionais.pePalito)    return 'pePalito'
  if (adicionais.rodinhas)    return 'rodinhas'
  return ''
}

// Espalha a `base` selecionada nas flags booleanas equivalentes — chamado
// antes de salvar o móvel pra Terceirizados/gerarResumo continuarem funcionando.
export function expandirBaseEmFlags(adicionais) {
  const b = adicionais?.base || ''
  return {
    ...adicionais,
    baseMadeira: b === 'madeira',
    baseMetalon: b === 'metalon',
    pePalito:    b === 'pePalito',
    rodinhas:    b === 'rodinhas',
  }
}
